import HighThcStrains from "./HighThcStrains";
export default HighThcStrains;
